import { TipoFile } from "../data/tipoFile"
import type { Produto } from "../types/produto.props"

interface MidiaProdutoVitrineProps {
    produto: Produto
    width: number
    height: number
    hoverImagensVitrine?: boolean
    hoverImagensVitrineMobile?: boolean
}

export function MidiaProdutoVitrine({
    produto,
    width,
    height,
    hoverImagensVitrine,
    hoverImagensVitrineMobile
}: MidiaProdutoVitrineProps){
    const isVideo =
        (Number(produto.midia_tipo_file) === TipoFile.VIDEO && produto.midia_path?.endsWith('.mp4')) ||
        ([TipoFile.VIDEO, TipoFile.DOCUMENTO].includes(Number(produto.midia_tipo_file)) &&
            produto.midia_arquivo_nome?.endsWith('.mp4'))

    const aspectRatio =
        width > 0 && height > 0 ? `${width} / ${height}` : undefined

    const urlVideo = produto.midia_path?.endsWith('.mp4')
        ? produto.midia_path
        : `/${produto.midia_path}${produto.midia_arquivo_nome}`

    const urlImagemPrincipal = `/${produto.midia_path}${produto.midia_arquivo_nome}`
    const urlImagemSecundaria = produto.midia_secundaria_path
        ? `/${produto.midia_secundaria_path}${produto.midia_secundaria_arquivo_nome}`
        : ''

    const isSecundariaVideo =
        [TipoFile.VIDEO, TipoFile.DOCUMENTO].includes(produto?.midias?.[1]?.tipo_file) &&
        produto?.midias?.[1]?.arquivo_nome?.endsWith('.mp4')

    // Exibe vídeo
    if (isVideo) {
        return (
            <video
                style={{ aspectRatio }}
                width={width > 0 ? width : undefined}
                height={height > 0 ? height : undefined}
                preload="none"
                className="lazyload"
                muted
                loop
                playsInline
                data-autoplay=""
            >
                <source src={urlVideo} type="video/mp4" />
            </video>
        )
    }

    // Exibe imagem com hover (imagem secundária ou vídeo secundário)
    if (hoverImagensVitrine || hoverImagensVitrineMobile) {
        return (
            <img
                alt={produto.nome}
                title={produto.nome}
                className="img-principal lazyload"
                data-sizes="auto"
                src={urlImagemPrincipal}
                data-imagem-principal={urlImagemPrincipal}
                data-imagem-secundaria={!isSecundariaVideo ? urlImagemSecundaria : ''}
                data-video-secundario={isSecundariaVideo ? urlImagemSecundaria : ''}
                width={width > 0 ? width : undefined}
                height={height > 0 ? height : undefined}
            />
        )
    }

    // Exibe imagem simples (sem hover)
    return (
        <img
            alt={produto.nome}
            title={produto.nome}
            className="lazyload"
            data-sizes="auto"
            src={urlImagemPrincipal}
            width={width > 0 ? width : undefined}
            height={height > 0 ? height : undefined}
        />
    )
}
